
import { Episode, Category } from "./types";

interface EpisodesStatsProps {
  paginatedEpisodes: Episode[];
  filteredEpisodes: Episode[];
  selectedCategory: string | null;
  categories: Category[];
  currentPage: number;
  totalPages: number;
}

const EpisodesStats = ({
  paginatedEpisodes,
  filteredEpisodes,
  selectedCategory,
  categories,
  currentPage,
  totalPages,
}: EpisodesStatsProps) => {
  return (
    <div className="mb-12 flex justify-between items-center">
      <p className="text-xl text-gray-600">
        Showing {paginatedEpisodes.length} of {filteredEpisodes.length} episode{filteredEpisodes.length !== 1 ? 's' : ''}
        {selectedCategory && (
          <span className="ml-2">
            in <span className="font-semibold" style={{ color: categories.find(c => c.id === selectedCategory)?.color || '#3B82F6' }}>
              {categories.find(c => c.id === selectedCategory)?.name}
            </span>
          </span>
        )}
        <span className="ml-4 text-gray-500">
          (Page {currentPage} of {totalPages})
        </span>
      </p>
    </div>
  );
};

export default EpisodesStats;
